<template>
  <div>
    <div class="manage--main">
        <!-- main -->
        <contentInfoUser></contentInfoUser>
    </div>
  </div>
</template>

<script>
import contentInfoUser from "@/components/personSet/contentInfoUser";
export default {
  components: {
   contentInfoUser
  },
  data() {
    return {};
  },
  created() {},
  beforeDestroy() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped>
.manage--main {
  position: relative!important;
}
.exam_btn.btn-login.disable {
    background: #d2d2d2 !important;
    cursor: no-drop;
}
.primarylists {
    margin-top: 15px;
    margin-left: 15px;
}
.nameStudent {
    color: #da251d;
}
.user-name {
    margin-left: 4px;
}
.user-name.ml {
    margin-left: 50px;
}
.user-namesss {
    font-weight: bold;
    padding: 0 5px;
    text-transform: uppercase;
    font-size: 18px;
    color: #fff;
    margin-left: 4px;
    text-overflow: ellipsis !important;
    overflow: hidden;
    white-space: nowrap;
}
.title-flex {
    display: flex;
    align-items: center;
}
.new-btn {
    margin: 0 0px 0 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/personSet/personSet.vue